import type { FC } from "react";
import { Link, Stack, Typography } from "@mui/material";
import { SlackIcon } from "../../../../styles/icons/slack";

export const NoAppsBanner: FC = () => {
  return (
    <Stack
      sx={{
        width: "100%",
        ml: 2,
        backgroundColor: "background.default",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "1px solid #D1D5DB",
        borderRadius: 0.5,
        py: 6,
        px: 4,
        gap: 3,
      }}
    >
      <SlackIcon sx={{ width: 56, height: 56 }} />
      <Typography variant="subtitle2" fontWeight={700} fontSize="14px">
        Ready to bring your messages to life in Slack? 🚀
      </Typography>
      <Typography variant="body2" fontWeight={400} fontSize="14px">
        Let’s get you set up! Reach out to our Implementation team at{" "}
        {<Link href="mailto:onboarding@changeengine.com">onboarding@changeengine.com</Link>} and
        start sending today.
      </Typography>
    </Stack>
  );
};
